import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { settings } from '../../../settings';
import { forgotPasswordType } from '../../models/Interfaces/forgotPassword';

@Injectable({
  providedIn: 'root',
})
export class ForgotpasswordService {
  api = settings.API_URL;
  constructor(private http: HttpClient) {}

  forgotPasswordRequest(
    forgotPasswordParams: forgotPasswordType,
  ): Observable<any> {
    return this.http.get(`${this.api}/api/login/requestCompanyActivationCode`, {
      params: { userName: forgotPasswordParams.email },
      responseType: 'text',
    });
  }

  forgotPasswordReceived(data: any) {
    return console.log(data);
  }
}
